import * as StyledComponents from '../../StyledComponents';
import { FeatureReleaseSheetDetails } from './FeatureReleaseSheetDetails';
import styled from "styled-components";
import {
  CustomScrollbarWrapper,
} from 'cdk-radial';


export const StyledCustomScrollbarWrapper = styled(CustomScrollbarWrapper)`
  height: calc(100% - 10px);
  overflow-x: hidden;
`;


export const FeatureReleaseSideSheetBody = (): JSX.Element => {
  return (
    <StyledComponents.StyledSideSheetBodyContainer>
      <StyledCustomScrollbarWrapper>
      <FeatureReleaseSheetDetails />
      </StyledCustomScrollbarWrapper>
    </StyledComponents.StyledSideSheetBodyContainer>
  );
};
